import React from "react";
import { SITE } from "../config/siteConfig";
import { phonesFor } from "../config/phoneConfig";
import { Layout } from "./Layout";
import { PhoneButton, CallButton } from "./PhoneButtons";
import { CheckIcon, AlertIcon, InfoIcon } from "./icons";
import useSeo from "../utils/seo";

// Contenu commun des pages d'atterrissage : accueil (sans marque) ou page d'une campagne marque.
export function Landing({ provider = null, path = "/" }) {
  const v = SITE.vertical;
  const phones = phonesFor(provider);
  const title = provider ? "¿Cliente de " + provider.name + "? " + v.seoTitle : v.seoTitle;
  useSeo({ title, description: v.seoDescription, path: provider ? path : "/" });

  return (
    <Layout provider={provider}>
      <section className="hero">
        <div
          className="hero-bg"
          aria-hidden="true"
          style={{ backgroundImage: "url(/images/hero-conseillere.webp)" }}
        />
        <div className="wrap hero-inner">
          <div className="hero-card">
            <p className="eyebrow">{v.eyebrow}</p>
            <h1>
              {provider ? (
                <>
                  ¿Cliente de {provider.name}?<br />
                  Compara las ofertas {v.product}
                </>
              ) : (
                v.homeTitle
              )}
            </h1>
            <p className="hero-sub">{v.homeSub}</p>
            <PhoneButton phone={phones.main} label="Comparar con un asesor" />
            <p className="price-note">Servicio de comparación gratuito · llamada a un fijo nacional según tu tarifa</p>
            <p className="hours-note">Asesores disponibles {SITE.hours}.</p>
            <ul className="bullets">
              {v.bullets.map((b) => (
                <li key={b}>
                  <i className="bullet-icon">
                    <CheckIcon size={16} />
                  </i>
                  {b}
                </li>
              ))}
            </ul>
            {provider && (
              <div className="brand-notice" role="note">
                <InfoIcon size={20} />
                <p>
                  <strong>
                    {SITE.brandName} no es {provider.name}
                  </strong>{" "}
                  y no actúa en su nombre. Somos un servicio de comparación editado por {SITE.company.name} (Barcelona).
                  Para cualquier consulta sobre tu contrato con {provider.name} ({v.existingContract}), contacta
                  directamente con {provider.name}
                  {provider.site ? (
                    <>
                      {" "}
                      a través de su web oficial:{" "}
                      <a href={"https://" + provider.site} target="_blank" rel="nofollow noopener noreferrer">
                        {provider.site}
                      </a>
                      .
                    </>
                  ) : (
                    " a través de los canales que figuran en tu factura."
                  )}
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {SITE.emergency && (
        <section className="wrap emergency" aria-labelledby="urgencias">
          <div className="emergency-box">
            <AlertIcon />
            <div>
              <h2 id="urgencias">{SITE.emergency.title}</h2>
              <p>{SITE.emergency.intro}</p>
              <ul>
                {SITE.emergency.items.map((e) => (
                  <li key={e.label}>
                    <strong>{e.label}:</strong> {e.value}.
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      )}

      <section className="wrap savings">
        <h2>{v.savingsTitle}</h2>
        <p>{v.savingsText}</p>
        <img
          src="/images/cliente-telephone.webp"
          alt="Clienta hablando por teléfono con un asesor"
          width="96"
          height="96"
          loading="lazy"
          decoding="async"
          className="avatar"
        />
        <CallButton phone={phones.main} label="Hablar con un asesor" />
      </section>

      <section className="wrap steps" aria-labelledby="como-funciona">
        <h2 id="como-funciona">¿Cómo funciona?</h2>
        <ol>
          <li>
            <span className="step-num">1</span>
            <div>
              <h3>Llamas</h3>
              <p>Te atiende un asesor de nuestro socio {SITE.hours}.</p>
            </div>
          </li>
          <li>
            <span className="step-num">2</span>
            <div>
              <h3>Compara por ti</h3>
              <p>
                Estudia tu situación y te presenta las ofertas {v.product} de {v.ourSuppliers}.
              </p>
            </div>
          </li>
          <li>
            <span className="step-num">3</span>
            <div>
              <h3>Tú decides</h3>
              <p>
                Si una oferta te interesa, te acompaña en la contratación. Eres libre de no contratar nada.
              </p>
            </div>
          </li>
        </ol>
      </section>

      <section className="wrap transparency" aria-labelledby="como-trabajamos">
        <h2 id="como-trabajamos">Cómo trabajamos</h2>
        <ul>
          <li>
            El servicio de comparación es gratuito. La llamada tiene el coste de una llamada a un fijo nacional, según
            tu operador.
          </li>
          <li>Las comparaciones no son exhaustivas: se basan en {v.supplierSelection}.</li>
          <li>
            Las llamadas las atienden los asesores de {v.partner}. Recibimos una comisión cuando se contrata una
            oferta, sin que afecte al precio que pagas.
          </li>
          <li>
            {SITE.brandName} no es {v.notA}. No tenemos acceso a tu contrato actual: para facturas, bajas,
            reclamaciones o averías, contacta con tu {v.supplierWord}.
          </li>
        </ul>
        <p className="more">
          Preguntas frecuentes: <a href="/preguntas-frecuentes">ver la FAQ</a> · Quiénes somos:{" "}
          <a href="/sobre-nosotros">sobre nosotros</a>
        </p>
      </section>
    </Layout>
  );
}
